import { render, staticRenderFns } from "./sistema-recursos-fdrles-transf.vue?vue&type=template&id=be6e330a&scoped=true"
import script from "./sistema-recursos-fdrles-transf.vue?vue&type=script&lang=js"
export * from "./sistema-recursos-fdrles-transf.vue?vue&type=script&lang=js"
import style0 from "./sistema-recursos-fdrles-transf.vue?vue&type=style&index=0&id=be6e330a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6e330a",
  null
  
)

export default component.exports